module.exports = __webpack_public_path__ + "static/img/s12.77d06c48.png";